import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import CookieWebWorkersHelper from 'redpoints-connector-common/helper/CookieWebWorkersHelper';

import {
  Button,
  Col,
  Modal,
  ModalProgress,
  Row,
} from 'redpoints-front-components/index';

import rpfdate from 'redpoints-front-date';

/**
 * Define prop types
 *
 * @param { active } Boolean
 * @param { onCancel } function
 */
const propTypes = {
  active: PropTypes.bool,
  onCancel: PropTypes.func,
  onFinishBulkAction: PropTypes.func,
  context: PropTypes.shape(),
  assetId: PropTypes.number,
  newStatus: PropTypes.bool,
  assetsSelected: PropTypes.arrayOf(PropTypes.object),
};

/**
 * Define default props
 *
 * @param { active } Boolean
 * @param { onCancel } function
 */
const defaultProps = {
  active: false,
  onCancel: () => {},
  onFinishBulkAction: () => {},
  context: {},
  assetId: null,
  newStatus: true,
  assetsSelected: [],
};
const defaultState = {
  ModalProcessing: false,
  ModalConfirmStop: false,
  ModalResult: false,
  processed: 0,
  processedOk: 0,
  processedFailure: 0,
};

const loadBulkWorker = async () => {
  return (await import('./bulkWorker.worker.js?worker&inline')).default;
};

class ModalBulkActions extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
    this.handleProcessingData = this.handleProcessingData.bind(this);
    this.handleStopProcessingData = this.handleStopProcessingData.bind(this);
    this.handleShowConfirmStop = this.handleShowConfirmStop.bind(this);
    this.handleCancelConfirmStop = this.handleCancelConfirmStop.bind(this);
    this.handleShowResults = this.handleShowResults.bind(this);
    this.manageProcessed = this.manageProcessed.bind(this);
    this.startWorker = this.startWorker.bind(this);
    this.stopWorker = this.stopWorker.bind(this);
    this.finishBulkAction = this.finishBulkAction.bind(this);
  }

  componentDidMount() {
    this.setState(defaultState);
  }

  componentWillUnmount() {
    if (this.worker) {
      this.worker.terminate();
    }
  }

  handleProcessingData() {
    this.setState({
      ModalProcessing: true,
    });
    this.startWorker();
  }

  handleShowConfirmStop() {
    this.setState({
      ModalConfirmStop: true,
    });
  }

  handleStopProcessingData() {
    this.props.onCancel();
    this.setState({
      ModalProcessing: false,
      ModalConfirmStop: false,
      ModalResult: true,
    });
    this.stopWorker();
  }

  handleCancelConfirmStop() {
    this.setState({
      ModalConfirmStop: false,
    });
  }

  handleShowResults() {
    this.setState({
      ModalProcessing: false,
      ModalResult: true,
    });
  }

  manageProcessed(message) {
    let { processed, processedOk, processedFailure } = this.state;
    message.data.data.forEach(resp => {
      processed += 1;
      if (resp._status === 204) {
        // eslint-disable-line no-underscore-dangle
        processedOk += 1;
      } else {
        processedFailure += 1;
      }
    });
    this.setState({
      processed,
      processedOk,
      processedFailure,
    });
  }

  async startWorker() {
    const { context, assetId, newStatus, assetsSelected } = this.props;
    if (window.Worker && !this.worker) {
      const BulkWorker = await loadBulkWorker();
      this.worker = new BulkWorker();

      CookieWebWorkersHelper.connect(this.worker);
      this.startTime = rpfdate().format('x');
      this.timeAvg = [];
      let startcalc = 0;

      this.worker.onmessage = message => {
        this.endTime = rpfdate().format('x');
        switch (message.data.type) {
          case 'result':
            if (startcalc !== 0) {
              this.timeAvg.push(this.endTime - startcalc);
            } else {
              this.timeAvg.push(this.endTime - this.startTime);
            }
            startcalc = rpfdate().format('x');
            this.manageProcessed(message);
            break;
          case 'finished':
            this.worker.terminate();
            this.props.onCancel();
            delete this.worker;
            break;
          default:
            break;
        }
      };

      this.worker.onerror = error => {
        // eslint-disable-next-line no-console
        console.error('Worker error: ', error);

        this.worker.terminate();
        delete this.worker;
        this.finishBulkAction();
      };
      this.worker.postMessage({
        type: 'start',
        data: assetsSelected,
        context,
        assetId,
        newStatus,
      });
    }
  }

  stopWorker() {
    if (this.worker) {
      this.worker.postMessage({
        type: 'close',
      });
    }
  }

  finishBulkAction() {
    this.setState(defaultState);
    this.props.onFinishBulkAction();
  }

  render() {
    const { active, assetsSelected } = this.props;
    const {
      ModalProcessing,
      processed,
      processedFailure,
      ModalConfirmStop,
      ModalResult,
    } = this.state;
    return (
      <React.Fragment>
        {/* MODAL ACCEPT PROCCESS */}
        {assetsSelected.length ? (
          <Modal
            title="Confirmation processing card selected"
            visible={active && !ModalProcessing}
            onOk={this.handleProcessingData}
            onCancel={this.props.onCancel}
            closable={false}
            maskClosable={false}
          >
            <div>
              <p>
                The total number of images selected is {assetsSelected.length}
              </p>
              <p>Do you want to continue?</p>
            </div>
          </Modal>
        ) : (
          <Modal
            title="Confirmation processing card selected"
            visible={active && !ModalProcessing}
            closable={false}
            maskClosable={false}
            footer={
              <Row className="add-rule-btn-container">
                <Col className="gutter-row" span={24}>
                  <Button type="primary" onClick={this.props.onCancel}>
                    Ok
                  </Button>
                </Col>
              </Row>
            }
          >
            <div>
              <p>There are no images selected</p>
            </div>
          </Modal>
        )}

        {/* MODAL PROGRESS WORKER */}
        <ModalProgress
          title="Processing Cards"
          visible={ModalProcessing}
          processed={processed}
          total={assetsSelected.length}
          onConfirmStop={this.handleShowConfirmStop}
          onContinue={this.handleShowResults}
          processedFailure={processedFailure}
        />
        {/* MODAL CONFIRM STOP */}
        <Modal
          title="Confirmation Stop bulk actions"
          visible={ModalProcessing && ModalConfirmStop}
          onOk={this.handleStopProcessingData}
          onCancel={this.handleCancelConfirmStop}
          closable={false}
          maskClosable={false}
        >
          <div>
            <p>Do you want to stop bulk actions?</p>
          </div>
        </Modal>

        {/* MODAL RESULT */}
        <Modal
          title="Result bulk actions"
          visible={ModalResult}
          closable={false}
          maskClosable={false}
          footer={
            <Row className="add-rule-btn-container">
              <Col className="gutter-row" span={24}>
                <Button type="primary" onClick={this.finishBulkAction}>
                  Ok
                </Button>
              </Col>
            </Row>
          }
        >
          <div>
            <p>The bulk action was applied in total of {processed} images</p>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

ModalBulkActions.propTypes = propTypes;
ModalBulkActions.defaultProps = defaultProps;

export default ModalBulkActions;
